import { workspace } from './workspace';

export const publicRoutes = $axios => ({
  workspace: workspace($axios),
});
